<template>
  <v-dialog v-model="dialogValue" max-width="300">
    <v-card class="pb-3">
      <v-progress-linear
        v-if="loading"
        indeterminate
        color="primary"
      ></v-progress-linear>
      <v-card-title>
        <v-icon left>mdi-cash-multiple</v-icon>
        Selecionar Parcelas
        <v-spacer />
        <v-icon @click="dialogClose">close</v-icon>
      </v-card-title>
      <template v-for="(item, j) in pagamento.fplanospagtos">
        <v-list-item :key="j" class="ml-3">
          <v-list-item-action>
            <v-checkbox
              multiple
              class="pr-3"
              v-model="planosVisiveis"
              :value="item.id"
              :label="item.qtdParcelas + ' parcela(s)'"
            />
          </v-list-item-action>
        </v-list-item>
      </template>
      <v-btn class="ml-7 mr-7 mt-3 mb-3" color="success" @click="salvar()">
        <v-icon left>mdi-content-save</v-icon>
        salvar
      </v-btn>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    dialog: Boolean,
    pagamento: Object,
  },
  data: () => ({
    loading: false,
    planosVisiveis: [],
  }),
  computed: {
    dialogValue: {
      get() {
        return this.dialog;
      },
      set() {
        this.dialogClose();
      },
    },
  },
  methods: {
    dialogClose() {
      this.$emit("dialogClose");
    },
    async salvar() {
      try {
        this.loading = true;

        const response = await this.axios.put(
          `/pagamentos/${this.pagamento.id}/planos`,
          {
            planosVisiveis: this.planosVisiveis,
          }
        );
        if (response.status == 204) {
          this.pagamento.planosVisiveis = this.planosVisiveis;
          this.$emit("addPagamento", this.pagamento.id);
          this.dialogClose();
          this.$store.dispatch("showSuccess", "Planos salvos com sucesso!");
        }
      } catch (error) {
        this.$store.dispatch("showError", error);
      } finally {
        this.loading = false;
      }

      if (this.planosVisiveis.length > 0) {
        this.pagamento.planosVisiveis = this.planosVisiveis;
        this.$emit("addPagamento", this.pagamento.id);
        this.dialogClose();
      } else
        this.$store.dispatch(
          "showError",
          "É necessário selecionar pelo menos um plano de pagamento!"
        );
    },
  },
  watch: {
    dialog() {
      if (this.dialog) {
        this.planosVisiveis = this.pagamento.planosVisiveis;
      }
    },
  },
};
</script>
